import React, { Fragment, useEffect } from "react";
import { useFieldArray } from "react-hook-form";
import {
  DSelect,
  HDatePicker,
  HInput,
  passParamsThrough,
} from "../../../../validation/HForm";
import DeleteIcon from "../../../../assets/icons/trash.svg";
import PlusIcon from "../../../../assets/icons/plus-small.svg";
import { useSelector } from "react-redux";
import { useDefaultValues } from "./constants";
import { formattingDate } from "../../../../helpers/common";
import { toSelectOption } from "./utils";

export const OperationFields = (props) => {
  const { control, setValue, nestedIndex, handleGetDealNumber } = props;
  const { dealsNumber } = useSelector(({ handbook }) => handbook);
  const { defaultDealOperation } = useDefaultValues();

  const { fields, remove, append } = useFieldArray({
    control,
    name: `suspiciousTransactions.${nestedIndex}.financeSuspiciousOperations`,
    keyName: "_id",
  });

  const handleDealChange = (selectedOption, index) => {
    if (selectedOption) {
      setValue(
        `suspiciousTransactions.${nestedIndex}.financeSuspiciousOperations.${index}.dealNumber`,
        toSelectOption(selectedOption.label)
      )}
  };

  useEffect(() => {
    if (fields.length === 0) {
      append(defaultDealOperation);
    }
  }, [append, defaultDealOperation, fields.length]);

  return passParamsThrough(
    <>
      <div className="col-span-2 text-right">
        <button
          className="action-item"
          type="button"
          onClick={() => append(defaultDealOperation)}
        >
          <span className="icon m-r-spacer">
            <PlusIcon />
          </span>
          <span>Добавить операцию</span>
        </button>
      </div>
      <div className="col-span-2">
        {fields.map((field, idx) => (
          <Fragment key={field._id}>
            <div
              key={field._id}
              className={`serviceInformationAdd-grid-container ${
                fields.length > 1 ? "with-delete" : "without-delete"
              }`}
            >
              <div className="col-span-1">
                <label className="form-element-label">
                  Финансовая операция
                </label>
                <DSelect
                  h="true"
                  name={`suspiciousTransactions.${nestedIndex}.financeSuspiciousOperations.${idx}.dealNumber`}
                  placeholder="Выберите операцию"
                  options={dealsNumber}
                  noOptionsMessage={() => "Нет результатов"}
                  loadingMessage={() => "Загрузка..."}
                  handleOptions={(value) => handleGetDealNumber(value)}
                  handleOnChange={(selectedOption) =>
                    handleDealChange(selectedOption, idx)
                  }
                  formatCreateLabel={(inputValue) => inputValue}
                  defaultValue={field.dealNumber}
                  isClearable
                  isCreatable
                />
              </div>
              <div className="col-span-1">
                <label className="form-element-label">
                  Дата финансовой операции
                </label>
                <HDatePicker
                  h="true"
                  className="input"
                  name={`suspiciousTransactions.${nestedIndex}.financeSuspiciousOperations.${idx}.dateTransaction`}
                  defaultValue={
                    field.dateTransaction
                      ? formattingDate(field.dateTransaction)
                      : null
                  }
                />
              </div>
              {fields.length > 1 && (
                <button
                  type="button"
                  className="button-icontrigger"
                  onClick={() => remove(idx)}
                >
                  <span className="icon">
                    <DeleteIcon />
                  </span>
                </button>
              )}
            </div>
            <HInput
                h="true"
                type="hidden"
                name={`suspiciousTransactions.${nestedIndex}.financeSuspiciousOperations.${idx}.id`}
                defaultValue={field.id}
            />
          </Fragment>
        ))}
      </div>
    </>,
    props
  );
};
